export default __webpack_public_path__ + "static/media/peoples.b7ac2c86.svg";